import MathHtml from 'components/imported-assessment/MathHtml'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import {isEmpty} from '../../../helpers/utils'

import questionHandlers from './question-handlers'
import {createPost} from '../../../helpers/command'
import {toDisplayPoints} from '../../../helpers/utils'

const useStyles = makeStyles(questionStyles)
 
export default function Question ({question, sections, context, globalIndex}) {

  const {id: questionId, sectionId} = question
  const {translate, quizQuestionTypes, quizAssessmentResults: assessment} = context

  const classes = useStyles()

  const assessmentLoaded = !context.quizSearch['assessment-results']

  const {results = {}} = assessment
  const result = results[questionId] || {}

  const count = sections.reduce((a, b) => a + b.questions.length, 0)

  const sectionIndex = sections.findIndex(s => s.id == sectionId)
  const section = sectionIndex >= 0 && sections[sectionIndex]

  const questionIndex = questionId && section ? section.questions.findIndex(q => q.id == questionId) : -1

  const {html} = question && question.premise || {}

  const premiseHtml = isEmpty(html) ? false : html

  const type = quizQuestionTypes.find(t => t.id == question.type) || {}

  const title = translate(type.name)

  const indexLabel = `${translate('questions').substring(0,1)}: ${globalIndex + 1}/${count}`

  const Handler = questionHandlers[type.name]

  const defaultPremiseLabel = `${type.name}-default-premise`
  const defaultPremise = translate(defaultPremiseLabel)
  const hasDefaultPremise = defaultPremiseLabel != defaultPremise

  return (
    <Box key={question.id} className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.title}>{title}{['fill-in-the-blanks', 'open-question'].indexOf(type.name) >= 0 ? '*' : ''}</Box>
        <Box className={classes.index}>{indexLabel}</Box>
      </Box>
      <Box className={classes.content}>
        {premiseHtml && (context.importedMath ? <MathHtml className={classes.premise} html={premiseHtml} /> : <div className={classes.premise} dangerouslySetInnerHTML={{__html: premiseHtml}} />)}
        {!premiseHtml && hasDefaultPremise && <Box className={classes.premise}>{defaultPremise}</Box>}
        <Box className={classes.question}>
          {assessmentLoaded && Handler && <Handler {...{context, question, section, questionIndex}} />}
        </Box>
      </Box>
      <Box className={classes.pointsSection}>
        <Box className={classes.points}>
          <Box className="label">{translate('points')}:</Box>
          <Box className="value">{toDisplayPoints(result.points)} {translate('of')} {result.total}</Box>
        </Box>
      </Box>
    </Box>
  )
}

function questionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    header: {
      display: 'flex',
      fontSize: '12pt',
      padding: '10px 20px',
      borderBottom: 'solid 1px #d0d5d8',
    },
    pointsSection: {
      display: 'flex',
      padding: '10px 20px',
      fontSize: '11pt',
      color: '#485160',
      backgroundColor: '#edf3ff',
      borderBottom: 'solid 1px #bedbe9',
      '& .label': {
        marginRight: 3
      },
      '& > div': {
        display: 'flex',
        '& > div': {
        ...verticalCentering
        },
        '&:first-child': {
          flexGrow: 1
        }
      }
    },
    button: {
      textDecoration: 'none',
      color: '#fff',
      display: 'flex',
      padding: '7px 15px',
      backgroundColor:'#2ca5ec',
      borderRadius: 3,
      '& >div': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      '& .label': {
        fontSize: '13pt'
      },
      cursor: 'pointer',
      '&:hover': {
      },
    },
    grant: {
      marginLeft: 20
    },
    points: {
    },
    question: {
      display: 'flex',
      flexGrow: 1
    },
    title: {
      flexGrow: 1,
      ...verticalCentering
    },
    index: {
      fontSize: '10pt',
      ...verticalCentering
    },
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 30,
      display: 'flex',
      flexDirection: 'column',
    },
    premise: {
      fontWeight: 'bold',
      fontSize: '12pt',
    },
  }
}

